// Values come from `terraform output` in infrastructure/test. The resources are defined in
// infrastructure/modules/homey-environment/homey-admin-v2-app-userpool.tf and
// homey-admin-v2-app.tf. Re-read them after any apply that replaces the API Gateway,
// the user pool or the app client.
export const environment = {
  production: false,
  // terraform output: admin_v2_api_url
  apiUrl: 'https://1dh74n6la5.execute-api.us-east-1.amazonaws.com',
  cognito: {
    // terraform output: admin_v2_user_pool_id
    userPoolId: 'us-east-1_iLso3ljln',
    // terraform output: admin_v2_app_client_id
    userPoolClientId: '5lbi8s33nbcktclv80ljt2vd5u',
    // Derived from the aws_cognito_user_pool_domain name, not a terraform output. This is an
    // AWS-hosted Cognito domain (the resource has no certificate_arn), so AWS manages its DNS.
    hostedUiDomain: 'homey-admin-v2-domain-test.auth.us-east-1.amazoncognito.com',
  },
  baseUrl: 'https://admin-v2.test.myhomey.io',
};
